import React from 'react';
import { Anchor, Text } from 'grommet';

export const NameColumn = (datum: any) => {
  return (
    <Anchor color="dark-2" href={datum.url}>
      <Text>{datum.name}</Text>
    </Anchor>
  );
};

export const ContributionsColumn = (datum: any) => (
  <Text>{datum.contributions}</Text>
);
